export const exactClaimBarcodeProducts = (items, barcode) => {
  if (!/^[0-9]{9}$/.test(barcode)) return [];
  const seen = new Set();
  return (Array.isArray(items) ? items : [])
    .filter((item) => {
      if (!item?.productId || seen.has(String(item.productId))) return false;
      if (String(item.barcodeShortcut) !== barcode && String(item.barcode) !== `8859${barcode}`) {
        return false;
      }
      seen.add(String(item.productId));
      return true;
    })
    .map((item) => ({
      ...item,
      productName: item.productNameTh || item.productName || item.productFullName || '',
      value: item.productId,
      label: `${item.productNameTh || item.productName || item.productFullName || ''} - ${
        item.itemCode || ''
      }`,
    }));
};
